import type { ReactNode } from 'react'

import {
  BuildingIcon,
  CalendarIcon,
  CellphoneMessageIcon,
  MoneyPieChartIcon,
  MoneyRotationIcon
} from 'components/new-icons'

export type CondominiumCreditBenefit = {
  id: string
  icon: ReactNode
  title: string
  description: string
}

// Ciano, e não o azul do design system: esta seção tem fundo azul-escuro, onde
// `blue-icon-default` praticamente desaparece.
const iconColor = 'var(--colors-cyan-background-pressed)'

export const condominiumCreditBenefits: CondominiumCreditBenefit[] = [
  {
    id: 'spread-project-cost',
    icon: <MoneyRotationIcon color={iconColor} />,
    title: 'Evite concentrar todo o custo de uma grande obra',
    description:
      'Distribuir o pagamento pode ajudar o condomínio a evitar que um único projeto comprometa de forma significativa o caixa ou exija uma cobrança extraordinária elevada.'
  },
  {
    id: 'anticipate-improvements',
    icon: <CalendarIcon color={iconColor} />,
    title: 'Antecipe melhorias importantes',
    description:
      'Com acesso a recursos para o projeto, o condomínio pode avaliar melhorias que talvez demorassem mais tempo para sair do papel apenas com o dinheiro disponível em caixa.'
  },
  {
    id: 'preserve-financial-planning',
    icon: <MoneyPieChartIcon color={iconColor} />,
    title: 'Preserve o planejamento financeiro',
    description:
      'Ao conhecer as condições de pagamento, síndico e condôminos conseguem projetar o impacto da operação nas contas futuras e acompanhar o orçamento com mais organização.'
  },
  {
    id: 'protect-infrastructure',
    icon: <BuildingIcon color={iconColor} />,
    title: 'Cuide da infraestrutura e do patrimônio',
    description:
      'Reformas, manutenção e modernização contribuem para a conservação das áreas comuns, a qualidade de uso do empreendimento e a valorização do patrimônio.'
  },
  {
    id: 'specialist-support',
    icon: <CellphoneMessageIcon color={iconColor} />,
    title: 'Tenha acompanhamento durante o processo',
    description:
      'A CashMe oferece orientação de especialistas financeiros para que o condomínio avance com mais informação e segurança na tomada de decisão.'
  }
]
